<div class="container leader-board" [appLoading]="topListLoading">
  <ng-container *ngIf="topList.length > 0">
    <div class="list-wrap">
      <div class="list-top">
        <app-img-carousel
          #swiperLeaderBoard
          [config]="swiperOptions"
          class="swiper side-swiper"
          [itemsData]="topList"
          (IndexChange)="slideChange($event)"
        >
          <ng-template #carouselItemTpl let-item let-idx="index">
            <div class="img-wrap">
              <ng-container *ngIf="!swiperReady">
                <div class="skeleton skeleton-loading"></div>
                <img
                  class="contest-img"
                  #contestImg
                  src="{{ item.bonusImgUrl }}"
                  alt=""
                  lazy="loading"
                  (load)="swiperReady = true"
                />
              </ng-container>
              <ng-container *ngIf="swiperReady">
                <img class="contest-img" src="{{ item.bonusImgUrl }}" alt="" lazy="loading" />
                <div class="cover-area">
                  <p class="contest-title">{{ item.title }}</p>
                  <div class="wrap">
                    <p class="time-title">{{ 'finish_in' | translate }}</p>
                    <div class="time-zone">
                      <p class="number">
                        {{
                          remainingTime.day > 0 && remainingTime.day < 10
                            ? '0' + remainingTime.day
                            : remainingTime.day || '00'
                        }}
                      </p>
                      <p>:</p>
                      <p class="number">
                        {{
                          remainingTime.hour > 0 && remainingTime.hour < 10
                            ? '0' + remainingTime.hour
                            : remainingTime.hour || '00'
                        }}
                      </p>
                      <p>:</p>
                      <p class="number">
                        {{
                          remainingTime.min > 0 && remainingTime.min < 10
                            ? '0' + remainingTime.min
                            : remainingTime.min || '00'
                        }}
                      </p>
                      <p>:</p>
                      <p class="number">
                        {{
                          remainingTime.sec > 0 && remainingTime.sec < 10
                            ? '0' + remainingTime.sec
                            : remainingTime.sec || '00'
                        }}
                      </p>
                    </div>
                  </div>
                  <!-- 暂时隐藏 -->
                  <div class="prize-pool" *ngIf="false">
                    <div class="tt">
                      {{ 'prize_pool' | translate }}
                    </div>
                    <div class="amount">
                      <img class="currenc-img" [src]="'USDT' | currencyIcon" lazy="loading" />
                      <p class="total">{{ 100 | currencyValue: 'USDT' }}</p>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-template>
        </app-img-carousel>
        <ng-container *ngIf="swiperReady && topList.length > 1">
          <div
            class="button-prev onact96-not mutual-opacity"
            [class.disabled]="rankLoading"
            (click)="swiperLeaderBoard?.slidePrev()"
          >
            <div class="box">
              <i class="icon-left-arrow"></i>
            </div>
          </div>
          <div
            class="button-next onact96-not mutual-opacity"
            [class.disabled]="rankLoading"
            (click)="swiperLeaderBoard?.slideNext()"
          >
            <div class="box">
              <i class="icon-right-arrow"></i>
            </div>
          </div>
        </ng-container>
      </div>
      <!-- [appLoading] -->
      <div class="list-content">
        <div class="rule">
          <div class="title onact96" (click)="showRule = !showRule">
            <div class="left">
              <i class="icon-warning"></i>
              <span>{{ 'battles_rules' | translate }}</span>
            </div>
            <i class="arrow icon-right-arrow" [class.up]="showRule"></i>
          </div>
          <ul class="content" [class.open]="showRule" [class.close]="!showRule">
            <li *ngIf="topList[selectedActivitIndex].introduction">
              <div class="txt gray">{{ topList[selectedActivitIndex].introduction }}</div>
            </li>
            <li>
              <div class="tt">{{ 'battle_type' | translate }}：</div>
              <div class="txt">{{ topList[selectedActivitIndex]?.type || '-' }}</div>
            </li>
            <li>
              <div class="tt">{{ 'level' | translate }}：</div>
              <div class="txt">{{ 'all_level' | translate }}</div>
            </li>
            <li>
              <div class="tt">{{ 'currency' | translate }}：</div>
              <div class="txt">
                {{ 'all_currencies' | translate }}
              </div>
            </li>
            <li>
              <div class="txt">
                {{ topList[selectedActivitIndex]?.introduction || '' }}
              </div>
            </li>
          </ul>
        </div>
        <div class="table-wrap" [appLoading]="rankLoading">
          <ng-container *ngIf="leaderBoardList.length > 0">
            <table>
              <thead>
                <tr>
                  <th *ngFor="let item of selectTitleData; let index = index" class="text-12">
                    {{ item.text }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of leaderBoardList">
                  <td>
                    <ng-container *ngIf="item?.rankNumber < 4">
                      <img
                        class="badge"
                        [src]="'assets/images/daily-races/' + (item?.rankNumber || 0) + '.svg'"
                        lazy="loading"
                        alt=""
                      />
                    </ng-container>
                    <ng-container *ngIf="item?.rankNumber >= 4">
                      <p class="rank-txt">{{ item?.rankNumber || 0 }}th</p>
                    </ng-container>
                  </td>
                  <td>
                    <div class="wrap">
                      <div class="avatar">
                        <img [src]="item.avatar | avatarDefault" lazy="loading" alt="" />
                        <p class="text-12">{{ item?.userName || item?.uid || '' }}</p>
                      </div>
                      <div class="players">
                        <ng-container *ngIf="selectedType == 2; else amountType">
                          <p class="text-12 gray-color">{{ item?.rankMoney }}x</p>
                        </ng-container>
                        <ng-template #amountType>
                          <p class="text-12 gray-color">
                            {{ item?.rankMoney || 0 | currencyValue: 'USDT' }}
                            <img [src]="'USDT' | currencyIcon" lazy="loading" alt="" />
                          </p>
                        </ng-template>
                      </div>
                    </div>
                  </td>
                  <td>
                    <p class="text-12 primary-color inline-block">
                      {{ dailyRacesService.toParseInt(item?.bonusUsdtMoney || 0) }}
                    </p>
                    <img class="ml-6" [src]="'USDT' | currencyIcon" lazy="loading" alt="" />
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="click-more onact96" (click)="openLeaderBoardPopup()">
              <span class="mutual-opacity"> {{ 'view_more' | translate }} <i class="icon-right-arrow"></i></span>
            </div>
          </ng-container>
          <app-empty class="mt-auto" *ngIf="leaderBoardList.length === 0 && !rankLoading"></app-empty>
        </div>
      </div>
    </div>
    <div class="relative-games">
      <div class="tt">
        <span>{{ 'participating_games' | translate }}({{ paginator.total }})</span>
      </div>
      <div class="list">
        <app-game-unit *ngFor="let item of games" [item]="item"></app-game-unit>
      </div>
      <app-paginator
        [alwaysH5]="true"
        [(page)]="paginator.page"
        [total]="paginator.total"
        [pageSize]="paginator.pageSize"
        (onPageChange)="getGameByProvider(false)"
        [loadMoreTemplate]="loadMoreTemplate"
        [loading]="gameLoading"
      >
      </app-paginator>
    </div>
  </ng-container>
  <app-empty class="mt-auto" *ngIf="topList.length === 0 && !topListLoading"></app-empty>
</div>

<ng-template #loadMoreTemplate>
  <div class="load-more mutual-opacity">
    {{ 'view_more' | translate }}
    <i class="icon-arrow-right-simple ml-6"></i>
  </div>
</ng-template>
